import { z } from 'zod';

/**
 * FTP connection schema for CSV file sync
 */
export const ftpConnectionSchema = z.object({
  baseDir: z.string().nullable().optional(),
  connectorType: z.literal('ftp'),
  delimiter: z.string().nullable().optional(),
  doublequote: z.boolean().nullable().optional(),
  escapechar: z.string().nullable().optional(),
  fileEncoding: z
    .literal(['iso-8859-1', 'utf-8', 'utf-8-sig', 'cp1252'])
    .default('iso-8859-1'),
  filePath: z.string().min(1),
  fileType: z.enum(['csv', 'json']).nullable().default('csv'),
  password: z.string().min(1),
  port: z.coerce.number().positive(),
  protocol: z.enum(['ftp', 'sftp']),
  quotechar: z.string().nullable().optional(),
  server: z.string().min(1),
  skipinitialspace: z.boolean().nullable().optional(),
  username: z.string().min(1),
});
